<template>
  <Layout>
    <div class="store">
      <div class="bg-white mb-5">
        <div class="container">
          <div class="global-slider">
            <div class="slider">
              <carousel :autoplay="true" :perPage="1" :paginationEnabled="false">
                <slide v-for="slide in slides" :key="slide.id">
                  <div class="slide-image">
                    <img :src="slide.img" />
                  </div>
                </slide>
              </carousel>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-xl-3 col-md-5 col-12 mb-3">
                  <a href="javascript:void(0)" class="newest">Terbaru</a>
                </div>
                <div class="col-xl-9 col-md-7 col-12 mb-3">
                  <div class="filterZiswafKategori">
                    <carousel
                      :perPage="3"
                      :paginationEnabled="false"
                      :navigationEnabled="true"
                      navigationNextLabel="<i class='fa fa-chevron-circle-right'></i>"
                      navigationPrevLabel="<i class='fa fa-chevron-circle-left'></i>"
                    >
                      <slide v-for="kategori in kategoriZiswaf" :key="kategori.code">
                        <div class="kategoriZiswaf">
                          <a href="javascript:void(0)" @click="fetchTerbaru(kategori.code)">{{ kategori.name }}</a>
                        </div>
                      </slide>
                    </carousel>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <a href="/report/search" class="all">
                Lihat Semua <span><i class="fa fa-arrow-right"></i></span>
              </a>
            </div>
          </div>

          <!-- card terbaru -->
          <div class="row">
            <template v-if="terbaruLoader">
              <div v-for="row in 8" :key="row.id" class="col-xl-3 col-md-6 col-sm-12">
                <skeleton-card></skeleton-card>
              </div>
            </template>
            <template v-else>
              <!-- nodata -->
              <template v-if="terbaru.length < 1">
                <div class="col-12">
                  <div class="alert-warning nodata">
                    No Data.
                  </div>
                </div>
              </template>
              <!-- data exists -->
              <template v-else>
                <div v-for="row in terbaru" :key="row.id" class="col-xl-3 col-md-6 col-sm-12">
                  <card :data="row"></card>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>

      <div class="bg-grey">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-3 mb-3">
                  <a href="javascript:void(0)" class="newest">Pilihan</a>
                </div>
                <div class="col-md-9 mb-3">
                  <div class="filterZiswafMitra">
                    <carousel
                      :perPage="3"
                      :paginationEnabled="false"
                      :navigationEnabled="true"
                      navigationNextLabel="<i class='fa fa-chevron-circle-right'></i>"
                      navigationPrevLabel="<i class='fa fa-chevron-circle-left'></i>"
                    >
                      <slide v-for="(kategori, index) in kategoriMitra" :key="kategori.code + index">
                        <div class="kategoriZiswaf">
                          <a href="javascript:void(0)" @click="fetchPilihan(kategori.code)">{{ kategori.name }}</a>
                        </div>
                      </slide>
                    </carousel>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <a href="/report/search" class="all">
                Lihat Semua <span><i class="fa fa-arrow-right"></i></span>
              </a>
            </div>
          </div>

          <!-- CARD MAIN -->
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <template v-if="pilihanLoader">
                  <div v-for="row in 8" :key="row.id" class="col-xl-3 col-md-6 col-sm-12">
                    <skeleton-card></skeleton-card>
                  </div>
                </template>
                <template v-else>
                  <!-- nodata -->
                  <template v-if="pilihan.length < 1">
                    <div class="col-12">
                      <div class="alert-warning nodata">
                        No Data.
                      </div>
                    </div>
                  </template>
                  <!-- data exists -->
                  <template v-else>
                    <div v-for="row in pilihan" :key="row.id" class="col-xl-3 col-md-6 col-sm-12">
                      <card :data="row"></card>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../views/layouts/Index.vue";
import { Carousel, Slide } from "vue-carousel";
import axios from "../../utils/masjedapi";
import Card from "./component/card.vue";
import SkeletonCard from "./component/skeletoncard.vue";
import CardMain from "./component/cardsolo.vue";
import CardList from "./component/cardlist.vue";

import moment from "moment";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Card,
    SkeletonCard,
    CardMain,
    CardList,
  },
  data() {
    return {
      slides: [],
      terbaruLoader: false,
      terbaru: [],
      kategoriZiswaf: [
        {
          code: "INFAQ",
          name: "INFAQ",
        },
        {
          code: "ZAKAT",
          name: "ZAKAT",
        },
        {
          code: "SEDEKAH",
          name: "SEDEKAH",
        },
        {
          code: "KURBAN",
          name: "KURBAN",
        },
        {
          code: "WAKAF",
          name: "WAKAF",
        },
      ],
      pilihanLoader: false,
      pilihan: [],
      kategoriMitra: [],
    };
  },
  created() {
    this.fetchSlide();
    this.fetchMitra();
    this.fetchTerbaru();
    this.fetchPilihan();
  },
  methods: {
    async fetchSlide() {
      const slides = await axios.get(`/store/slide`);
      const { data } = slides.data;
      this.slides = data;
    },
    async fetchMitra() {
      const mitra = await axios.get(`/store/mitra`);
      const { data } = mitra.data;
      this.kategoriMitra = data;
    },
    async fetchTerbaru(type = "") {
      this.terbaruLoader = true;
      let url = `/store/terbaru`;
      if (type) url = url + `?type=${type}`;
      const terbaru = await axios.get(url);
      const { data } = terbaru.data;
      this.terbaru = data;
      this.terbaruLoader = false;
    },
    async fetchPilihan(mitra = "") {
      this.pilihanLoader = true;
      let url = `/store/pilihan`;
      if (mitra) url = url + `?mitra=${mitra}`;
      const terbaru = await axios.get(url);
      const { data } = terbaru.data;
      this.pilihan = data;
      this.pilihanLoader = false;
    },
  },
};
</script>

<style lang="scss" scoped>
ul.list {
  display: flex;
  list-style-type: none;
  padding: 10px 0px;
  margin: 0px;
  li:first-child {
    font-size: 30px;
    color: #28a745 !important;
    font-weight: 500;
  }

  li {
    padding: 10px 0px;
    margin-right: 30px;
    font-size: 25px;
    color: #888;
  }
}

.filterZiswafKategori {
  padding-left: 15px;
  .kategoriZiswaf {
    height: 100% !important;
    margin-right: 30px;
    position: relative;

    a {
      text-decoration: none;
      color: #888;
      font-weight: 400;
      font-size: 18px;
      position: relative;
      top: 2px;
      padding-left: 10px;
    }
  }
}
.filterZiswafMitra {
  padding-left: 15px;
  .kategoriZiswaf {
    height: 100% !important;
    margin-right: 30px;
    position: relative;
    width: 300px;

    a {
      text-decoration: none;
      color: #888;
      font-weight: 400;
      font-size: 18px;
      position: relative;
      top: 2px;
      padding-left: 10px;
    }
  }
}
</style>
